<template>
  <div>
    <div
      v-if="error"
      class="text-center py-3"
    >
      <p class="text-danger mb-1">
        {{ $t('mySubtasks.table.error') }}
      </p>
      <b-button
        variant="outline-danger"
        size="sm"
        @click="fetchData()"
      >
        {{ $t('common.retry') }}
      </b-button>
    </div>
    <b-table
      v-else
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      :busy="loading"
      show-empty
      :empty-text="$t('mySubtasks.table.empty')"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle" />
          <strong class="ml-2">{{ $t('common.loading') }}</strong>
        </div>
      </template>

      <template #cell(task_title)="data">
        <router-link :to="taskLink(data.item)">
          {{ data.item.task_title }}
        </router-link>
      </template>

      <template #cell(target_date)="data">
        {{ data.item.target_date ? moment(data.item.target_date).format('DD.MM.YYYY') : '—' }}
      </template>

      <template #cell(priority)="data">
        <priority-text :priority-id="data.item.id_task_priorities" />
      </template>

      <template #cell(control)="data">
        <b-button
          variant="outline-primary"
          size="sm"
          pill
          :to="taskLink(data.item)"
        >
          {{ $t('mySubtasks.table.goToTask') }}
        </b-button>
      </template>
    </b-table>

    <b-card-footer v-if="!error && dataCounts > perPage">
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import {
  BButton, BCardFooter, BPagination, BSpinner, BTable,
} from 'bootstrap-vue'
import PriorityText from '@/components/PriorityText.vue'
import { definitionId } from '@/libs/definitions'

export default {
  name: 'MySubtasksTable',
  components: {
    BButton, BCardFooter, BPagination, BSpinner, BTable, PriorityText,
  },
  props: {
    // subtask durum slug'ı: open, completed, manager_cancelled
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      requestId: 0,
      loading: false,
      error: false,
      dataList: [],
      dataCounts: 0,
    }
  },
  computed: {
    fields() {
      return [
        { key: 'title', label: this.$t('mySubtasks.columns.subtask') },
        { key: 'task_title', label: this.$t('mySubtasks.columns.task') },
        { key: 'target_date', label: this.$t('fields.targetDate'), thClass: 'width-150' },
        { key: 'priority', label: this.$t('fields.priority'), thClass: 'width-150' },
        {
          key: 'control', label: '', thClass: 'width-150', tdClass: 'text-nowrap',
        },
      ]
    },
  },
  watch: {
    currentPage() {
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    taskLink(item) {
      return `/app/tasks/detail/${item.id_tasks}`
    },
    async fetchData() {
      // Hızlı sayfa geçişinde geç gelen eski yanıt yeni sayfanın üstüne yazılmasın.
      this.requestId += 1
      const { requestId } = this
      this.loading = true
      this.error = false
      try {
        const res = await this.$store.dispatch('subtasks/getMyList', {
          id_subtask_statuses: definitionId('subtask', this.status),
          limit: this.perPage,
          start: (this.currentPage - 1) * this.perPage,
        })
        if (requestId !== this.requestId) return
        this.dataList = res.data
        this.dataCounts = res.count
      } catch (e) {
        if (requestId === this.requestId) this.error = true
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
  },
}
</script>
